import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { AuthGuard } from '@auth0/auth0-angular';

import { PERMISSIONS_GROUPS } from './core/constants/permission-group.constants';
import { permissionGuard } from './core/guard/permission.guard';
import { RecommendationV2Module } from './modules/recommendation-v2/recommendation-v2.module';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule),
  },
  {
    path: 'pharmasync',
    loadChildren: () => import('./modules/pharmasync/pharmasync.module').then(m => m.PharmasyncModule),
  },
  {
    path: 'cadastro',
    loadComponent: () => import('./modules/register/register.component').then(mod => mod.RegisterComponent)
  },
  {
    // Rota PÚBLICA de propósito: é uma isca de captação e o visitante não tem
    // conta. Sem AuthGuard e sem permissionGuard — e, por isso, o caminho
    // também precisa entrar em shouldShowHeader() no app.component.ts.
    path: 'diagnostico-pdv',
    loadComponent: () => import('./modules/performance-pdv/performance-pdv.component').then(mod => mod.PerformancePdvComponent)
  },
  // {
  //   path: 'home',
  //   loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule),
  //   canActivate: [AuthGuard, permissionGuard],
  //   data: { requiredGroup: [PERMISSIONS_GROUPS.interno, PERMISSIONS_GROUPS.freemium, PERMISSIONS_GROUPS.inativo, PERMISSIONS_GROUPS.licenciado] }
  // },
  {
    path: 'home',
    loadComponent: () => import('./modules/home-v2/pages/home/home.component').then(m => m.HomeComponent),
    canActivate: [AuthGuard, permissionGuard],
    data: { requiredGroup: [PERMISSIONS_GROUPS.interno, PERMISSIONS_GROUPS.freemium, PERMISSIONS_GROUPS.otimiza, PERMISSIONS_GROUPS.inativo, PERMISSIONS_GROUPS.licenciado] }
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./modules/dashboards/dashboards.module').then(m => m.DashboardsModule),
    canActivate: [AuthGuard, permissionGuard],
    data: { requiredGroup: PERMISSIONS_GROUPS.dashboard }
  },
  {
    path: 'file-manager',
    loadChildren: () => import('./modules/visualizacao-de-arquivos/visualizacao-de-arquivos.module').then(m => m.VisualizacaoDeArquivosModule),
    canActivate: [AuthGuard, permissionGuard],
    data: { requiredGroup: PERMISSIONS_GROUPS.fileManager }
  },
  {
    path: 'pbm',
    loadChildren: () => import('./modules/pmb/pbm.module').then(m => m.PbmModule),
    canActivate: [AuthGuard, permissionGuard],
    data: { requiredGroup: PERMISSIONS_GROUPS.pbm }
  },
  // {
  //   path: 'recomendacao',
  //   loadChildren: () => import('./modules/recommendation/recommendation.module').then(m => m.RecommendationModule),
  //   canActivate: [AuthGuard, permissionGuard],
  //   data: { requiredGroup: PERMISSIONS_GROUPS.recomendation }
  // },
  {
    path: 'recomendacao',
    loadChildren: () => import('./modules/recommendation-v2/recommendation-v2.module').then(m => m.RecommendationV2Module),
    canActivate: [AuthGuard, permissionGuard],
    data: { requiredGroup: PERMISSIONS_GROUPS.recomendation }
  },
  {
    path: 'ai',
    loadChildren: () => import('./modules/ai/ai.module').then(m => m.AiModule),
    canActivate: [AuthGuard, permissionGuard],
    data: { requiredGroup: PERMISSIONS_GROUPS.chat }
  },
  {
    path: 'produtos-mais-vendidos-regiao',
    loadComponent: () => import('./modules/brick/brick.component').then(mod => mod.BrickComponent),
    canActivate: [AuthGuard, permissionGuard],
    data: { requiredGroup: PERMISSIONS_GROUPS.brick }
  },
  {
    path: 'potencial-ponto-comercial',
    loadComponent: () => import('./modules/potencial-do-ponto-comercial/potencial-do-ponto-comercial.component').then(mod => mod.PotencialDoPontoComercialComponent),
    canActivate: [AuthGuard, permissionGuard],
    data: { requiredGroup: PERMISSIONS_GROUPS.potencialDoPontoComercial }
  },
  {
    path: 'precificacao',
    loadChildren: () => import('./modules/midas/midas.module').then(m => m.MidasModule),
    canActivate: [AuthGuard, permissionGuard],
    data: { requiredGroup: PERMISSIONS_GROUPS.precification }
  },
  {
    path: 'termos',
    loadChildren: () => import('./modules/terms/terms.module').then(m => m.TermsModule),
    canActivate: [AuthGuard, permissionGuard],
    data: { requiredGroup: PERMISSIONS_GROUPS.term }
  },
  {
    path: 'certificado',
    loadChildren: () => import('./modules/certificate/certificate.module').then(m => m.CertificateModule),
    canActivate: [AuthGuard, permissionGuard],
    data: { requiredGroup: PERMISSIONS_GROUPS.certificate }
  },
  {
    path: 'extrato-financeiro',
    loadChildren: () => import('./modules/bill-assistant/bill-assistant.module').then(m => m.BillAssistantModule),
    canActivate: [AuthGuard, permissionGuard],
    data: { requiredGroup: PERMISSIONS_GROUPS.billing }
  },
  {
    path: 'tutoriais',
    loadChildren: () => import('./modules/tutorial/tutorial.module').then(m => m.TutorialModule),
    canActivate: [AuthGuard, permissionGuard],
    data: { requiredGroup: [PERMISSIONS_GROUPS.interno, PERMISSIONS_GROUPS.licenciado] }
  },
  {
    path: 'descredenciamento',
    loadChildren: () => import('./modules/unlicense/unlicense.module').then(m => m.UnlicenseModule),
    canActivate: [AuthGuard, permissionGuard],
    data: { requiredGroup: PERMISSIONS_GROUPS.term }
  },
  {
    path: 'ofertas',
    loadChildren: () => import('./modules/offers/offers.module').then(m => m.OffersModule),
    canActivate: [AuthGuard, permissionGuard],
    data: { requiredGroup: [PERMISSIONS_GROUPS.interno, PERMISSIONS_GROUPS.licenciado] }
  },
  {
    path: 'onboard',
    loadChildren: () => import('./modules/check-docs/check-docs.module').then(m => m.CheckDocsModule),
    canActivate: [AuthGuard, permissionGuard],
    data: { requiredGroup: PERMISSIONS_GROUPS.term }
  },
  {
    path: 'documentos',
    loadChildren: () => import('./modules/documents/documents.module').then(m => m.DocumentsModule),
    canActivate: [AuthGuard, permissionGuard],
    data: { requiredGroup: PERMISSIONS_GROUPS.term }
  },
  {
    path: 'agendamento',
    loadChildren: () => import('./modules/agendamento/agendamento.module').then(m => m.AgendamentoModule),
    canActivate: [AuthGuard, permissionGuard],
    data: { requiredGroup: [PERMISSIONS_GROUPS.interno, PERMISSIONS_GROUPS.licenciado] }
  },
  {
    path: 'cotar-produtos',
    loadChildren: () => import('./modules/quote-v2/quote-v2.module').then(m => m.QuoteV2Module),
    canActivate: [AuthGuard, permissionGuard],
    data: { requiredGroup: PERMISSIONS_GROUPS.shopping }
  },
  {
    // Área de gestão (ex-PharmaManager). Primeira camada de autorização: grupo Auth0.
    // A segunda, por tela, vive em `gestao-routing.module.ts`.
    path: 'gestao',
    loadChildren: () => import('./modules/gestao/gestao-routing.module').then(m => m.GestaoRoutingModule),
    canActivate: [AuthGuard, permissionGuard],
    data: { requiredGroup: PERMISSIONS_GROUPS.gestao }
  },
  {
    path: 'jornal-ofertas',
    loadComponent: () => import('./modules/flyer/flyer.component').then(m => m.FlyerComponent),
    canActivate: [AuthGuard, permissionGuard],
    data: { requiredGroup: [PERMISSIONS_GROUPS.interno] }
  },
  // Redirects legados do PharmaManager → área de gestão (T042). `/cadastro/*` e `/dashboard/*`
  // ficam de fora de propósito: colidem com rotas próprias do Otimiza (registro público e
  // dashboards do produto). O específico vem antes do genérico (`product/...` antes de `product`).
  { path: 'list-users', redirectTo: 'gestao/usuarios', pathMatch: 'full' },
  { path: 'list-economic-group', redirectTo: 'gestao/grupos-economicos', pathMatch: 'full' },
  { path: 'pharmaceutical-market-analysis', redirectTo: 'gestao/analise-de-mercado', pathMatch: 'full' },
  { path: 'list-contracts', redirectTo: 'gestao/contratos', pathMatch: 'full' },
  { path: 'ativar-precificacao', redirectTo: 'gestao/ativar-precificacao', pathMatch: 'full' },
  { path: 'score', redirectTo: 'gestao/score', pathMatch: 'full' },
  { path: 'product/search-by-product', redirectTo: 'gestao/produtos/busca', pathMatch: 'full' },
  { path: 'product', redirectTo: 'gestao/produtos', pathMatch: 'full' },
  { path: 'gerencia-credenciais', redirectTo: 'gestao/gerencia-credenciais', pathMatch: 'full' },
  { path: 'gerador-url', redirectTo: 'gestao/gerador-url', pathMatch: 'full' },
  {
    path: '**',
    loadChildren: () => import('./modules/not-found/not-found.module').then(m => m.NotFoundModule)
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
